import { Controller } from "@hotwired/stimulus"

// Rozwija fragment strony (np. edytor treści notatki ze spotkania) na całe okno przeglądarki, przykrywając
// resztę strony - przy udostępnianiu ekranu na wideo widać tylko treść. Esc albo ten sam przycisk wraca
// do zwykłego widoku. Pola z `stretchSelector` (domyślnie contenteditable edytora) dostają wtedy wysokość okna.
// Target `header` (np. małe okruszki) widać tylko na pełnym ekranie; target `title` dostaje przy wejściu
// bieżącą wartość pola `titleInput` (selektor), bo tytuł mógł się zmienić od wczytania strony.
export default class extends Controller {
  static targets = ["openIcon", "closeIcon", "button", "header", "title"]
  static values = {
    openLabel: String,
    closeLabel: String,
    titleInput: String,
    stretchSelector: { type: String, default: "[contenteditable='true']" },
  }

  connect() {
    this.active = false
    this.onKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    if (this.active) this.exit()
  }

  toggle() {
    if (this.active) {
      this.exit()
    } else {
      this.enter()
    }
  }

  enter() {
    this.active = true
    this.element.classList.add(...FULLSCREEN_CLASSES)
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.onKeydown)
    this.stretchElements().forEach((el) => {
      el.dataset.fullscreenBoxMinHeight = el.style.minHeight
      el.style.minHeight = "calc(100dvh - 7rem)"
    })
    this.syncTitle()
    this.render()
  }

  exit() {
    this.active = false
    this.element.classList.remove(...FULLSCREEN_CLASSES)
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.onKeydown)
    this.stretchElements().forEach((el) => {
      el.style.minHeight = el.dataset.fullscreenBoxMinHeight || ""
      delete el.dataset.fullscreenBoxMinHeight
    })
    this.render()
  }

  stretchElements() {
    return this.element.querySelectorAll(this.stretchSelectorValue)
  }

  syncTitle() {
    if (!this.hasTitleTarget || !this.titleInputValue) return
    const input = document.querySelector(this.titleInputValue)
    if (input) this.titleTarget.textContent = input.value.trim()
  }

  onKeydown(event) {
    if (event.key === "Escape") this.exit()
  }

  render() {
    if (this.hasOpenIconTarget) this.openIconTarget.classList.toggle("hidden", this.active)
    if (this.hasCloseIconTarget) this.closeIconTarget.classList.toggle("hidden", !this.active)
    if (this.hasHeaderTarget) this.headerTarget.classList.toggle("hidden", !this.active)
    if (this.hasButtonTarget) {
      const label = this.active ? this.closeLabelValue : this.openLabelValue
      this.buttonTarget.title = label
      this.buttonTarget.setAttribute("aria-label", label)
      this.buttonTarget.setAttribute("aria-pressed", String(this.active))
    }
  }
}

// nakładka na całe okno; bg-white odwraca się w trybie ciemnym; u góry mały odstęp, żeby treść zaczynała się od razu
export const FULLSCREEN_CLASSES = ["fixed", "inset-0", "z-[60]", "bg-white", "overflow-y-auto", "px-4", "pt-2", "pb-4", "sm:px-8", "sm:pb-6"]
